/**
 * NDK Pack Builder — «Crea tu Pack»
 *
 * DOS REGLAS DISTINTAS, A PROPÓSITO:
 *   · El DESCUENTO es de línea. Se calcula sobre las unidades del pack y lo aplica de verdad la
 *     Shopify Function sobre las líneas con la propiedad `_ndk_pack`. Aquí solo se ANTICIPA lo
 *     que va a cobrar el carrito; si los dos números no coinciden al céntimo, es un bug.
 *   · El REGALO es de carrito. Se calcula en EUROS sobre el total post-descuento del carrito
 *     ENTERO — incluido lo que el cliente ya traía de una ficha. Es exactamente la regla de
 *     utcart-v2.js y no se reinventa.
 *
 * Ni los tramos ni los umbrales están escritos en este fichero: llegan del metafield de tienda y
 * de los ajustes del theme a través del JSON que inyecta la sección.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-ndk-pack-root]');
  if (!root) return;

  // ---------------------------------------------------------------- configuración
  function readJSON(id, fallback) {
    var el = document.getElementById(id);
    if (!el) return fallback;
    try { return JSON.parse(el.textContent); } catch (e) {
      console.warn('NDK Pack: JSON ilegible en #' + id, e);
      return fallback;
    }
  }

  var CFG = readJSON('ndk-pack-config', {});
  var GIFTS = readJSON('ndk-pack-gifts', []);
  var TIERS = (CFG.tiers || []).slice().sort(function (a, b) { return a.min_units - b.min_units; });
  var T1 = CFG.threshold_gift_1 || 7000;
  var T2 = CFG.threshold_gift_2 || 12000;
  // OJO: estos valores llegan de `settings.checked_2` y `checked_3` (en euros, ×100 en la sección).
  // Son los MISMOS que lee utcart-v2.js. Si alguna vez vuelven vacíos, los `||` de arriba mienten
  // en silencio y la página promete un regalo que el carrito borra.
  var MAX_GIFTS = Math.min(2, GIFTS.length);
  var MIN_UNITS = TIERS.length ? TIERS[0].min_units : 2;

  // ---------------------------------------------------------------- utilidades
  function money(c) { return (c / 100).toFixed(2).replace('.', ',') + '\u00a0€'; }
  // Los importes redondos se enseñan sin decimales: «70 €», no «70,00 €». Es como lo escribió Julia
  // y como lo lee cualquiera. Los que no son redondos mantienen los céntimos: «32,03 €».
  function moneyShort(c) { return (c % 100 === 0 ? String(c / 100) : (c / 100).toFixed(2).replace('.', ',')) + '\u00a0€'; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]; }); }
  function teal(s) { return '<span class="t">' + s + '</span>'; }
  function plural(n, one, many) { return n === 1 ? one : many; }

  /**
   * Subtítulo de la línea del pack. 22 de los 27 productos tienen días (en `custom.days` o en el
   * título de la variante) y con cantidad 2 pasan a «60 días». Los 5 que no son productos por
   * días (Meno Essence, Rilaxan, Long Essence, B·Hair, Green Booster) usan la descripción de la
   * variante, pluralizando la unidad: «1 bote de 60 cápsulas» → «2 botes de 60 cápsulas».
   */
  function lineSubtitle(item) {
    if (item.days > 0) return (item.days * item.qty) + ' días';
    if (!item.unitDesc) return '';
    if (item.qty === 1) return item.unitDesc;
    return item.unitDesc.replace(/^1\s+(\S+)/, function (_, unit) {
      return item.qty + ' ' + (/d$/.test(unit) ? unit + 'es' : unit + 's');
    });
  }

  function ga(event, params) {
    try {
      if (window.dataLayer && window.dataLayer.push) window.dataLayer.push(Object.assign({ event: event }, params || {}));
      else if (typeof window.gtag === 'function') window.gtag('event', event, params || {});
    } catch (e) { /* la analítica nunca puede romper la compra */ }
  }

  /**
   * Los productos del pack en el formato de comercio electrónico de GA4. Sin esto el `add_to_cart`
   * del pack viajaba sin `items` y sin `value`: el evento de MAYOR ticket de la tienda valía 0 € en
   * los informes y no llevaba ni un identificador de producto.
   */
  function gaItems() {
    var p = pct();
    return state.pack.map(function (l) {
      var it = catalog[l.variantId];
      return {
        item_id: it.productId,
        item_name: it.title,
        item_variant: it.variantId,
        price: unitFinal(it.price, p) / 100,
        discount: (it.price - unitFinal(it.price, p)) / 100,
        quantity: l.qty
      };
    });
  }

  /*
   * NDK 2026-10: el «Added to Cart» de Klaviyo ya no se manda desde aquí. Lo manda
   * snippets/ndk-klaviyo-atc.liquid (en todas las páginas) al ver el /cart/add.js del pack;
   * si se mandara también aquí, saldría duplicado.
   */

  // ---------------------------------------------------------------- catálogo (del DOM)
  var cards = [].slice.call(root.querySelectorAll('[data-ndk-card]'));
  var catalog = {};
  cards.forEach(function (el) {
    var id = el.dataset.variantId;
    catalog[id] = {
      variantId: id,
      productId: el.dataset.productId,
      handle: el.dataset.handle,
      title: el.dataset.title,
      image: el.dataset.image,
      price: parseInt(el.dataset.price, 10) || 0,
      days: parseInt(el.dataset.days, 10) || 0,
      unitDesc: el.dataset.unitDesc || '',
      available: el.dataset.available === '1',
      collections: (el.dataset.collections || '').trim().split(/\s+/),
      el: el
    };
  });

  // ---------------------------------------------------------------- estado
  var state = {
    pack: [],            // [{ variantId, qty }]
    gifts: [],           // [variantId]
    cartOtherTotal: 0,   // céntimos del carrito que NO son del pack ni regalos
    // ¿Hay ya un pack en el carrito? Cambia el sentido del CTA: «Añadir» pasa a «Actualizar»,
    // «Ver el carrito» o «Quitar el pack» según lo que haya cambiado en la página.
    inCart: false,
    // Firma (productos+cantidades+regalos) del pack tal y como está en el carrito. Si la página
    // coincide, no hay nada que aplicar; si no, hay «cambios sin aplicar».
    cartSig: '',
    busy: false,
    // Cambios que el cliente ha hecho en la página y todavía no ha confirmado con el CTA.
    // Mientras esté a true, NADA puede sobrescribir state.pack: la resincronización que se
    // dispara al cerrar el carrito le borraba al cliente los productos que acababa de elegir.
    dirty: false
  };

  // Descarta respuestas de /cart.js que lleguen tarde y pisen un estado más nuevo.
  var loadGen = 0;

  function find(variantId) {
    for (var i = 0; i < state.pack.length; i++) if (state.pack[i].variantId === variantId) return state.pack[i];
    return null;
  }

  // ---------------------------------------------------------------- cálculo
  function units() { return state.pack.reduce(function (n, l) { return n + l.qty; }, 0); }

  function pct() {
    var u = units(), p = 0;
    for (var i = 0; i < TIERS.length; i++) if (u >= TIERS[i].min_units) p = TIERS[i].percentage;
    return p;
  }

  function nextTier() {
    var u = units();
    for (var i = 0; i < TIERS.length; i++) if (u < TIERS[i].min_units) return TIERS[i];
    return null;
  }

  function lineGross(l) { return catalog[l.variantId].price * l.qty; }

  /**
   * REDONDEO — replica exacta de lo que hace Shopify, medido contra el carrito real el 31-ago-2026.
   *
   * Shopify NO redondea el precio final: TRUNCA el descuento, y lo hace POR UNIDAD, no sobre el
   * importe de la línea. Es decir `unidad - floor(unidad * pct/100)`, multiplicado por la cantidad.
   *
   * Comprobado con datos reales: 34,95 con −25% → descuento 873,75 céntimos → truncado a 873 →
   * la tienda cobra 26,22 €. Redondear el precio daba 26,21 € y la página prometía un céntimo
   * menos de lo que se cobraba, en 19 de los 81 casos (27 productos × 3 tramos), todos en −25%.
   *
   * Este es el único sitio donde vive la fórmula. Si algún día Shopify cambia el criterio, se
   * cambia aquí y en ningún otro lado.
   */
  function unitFinal(unitPrice, p) { return unitPrice - Math.floor(unitPrice * p / 100); }

  function lineFinal(l) { return unitFinal(catalog[l.variantId].price, pct()) * l.qty; }

  function packSubtotal() { return state.pack.reduce(function (n, l) { return n + lineGross(l); }, 0); }
  function packTotal() { return state.pack.reduce(function (n, l) { return n + lineFinal(l); }, 0); }
  function packDiscount() { return packSubtotal() - packTotal(); }

  function giftEligible() { return packTotal() + state.cartOtherTotal; }
  function giftCount() {
    var c = giftEligible();
    return Math.min(c >= T2 ? 2 : c >= T1 ? 1 : 0, MAX_GIFTS);
  }
  function nextGiftThreshold() {
    var c = giftEligible();
    if (c < T1) return T1 - c;
    if (c < T2 && MAX_GIFTS > 1) return T2 - c;
    return 0;
  }

  // ---------------------------------------------------------------- textos
  function headlineHTML() {
    var u = units(), p = pct(), nt = nextTier();
    if (u === 0) return 'Elige ' + teal('<b>' + MIN_UNITS + ' productos</b>') + ' y empieza a ahorrar';
    if (p === 0) {
      var falta = MIN_UNITS - u;
      return 'Elige ' + teal('<b>' + falta + ' ' + plural(falta, 'producto más', 'productos más') + '</b>') + ' y empieza a ahorrar';
    }
    if (nt) {
      var mas = nt.min_units - u;
      return teal('&minus;' + p + '% aplicado') + ' · añade ' + teal(mas + ' más') + ' → ' + teal('&minus;' + nt.percentage + '%');
    }
    var falta2 = nextGiftThreshold();
    if (falta2 > 0 && giftCount() >= 1) {
      return teal('&minus;' + p + '% aplicado') + ' · te faltan ' + teal(moneyShort(falta2)) + ' para un ' + teal('2º regalo');
    }
    return teal('&minus;' + p + '% aplicado');
  }

  function giftTextHTML() {
    var n = giftCount(), falta = nextGiftThreshold();
    // NDK 9-sep-2026 (revisión Paolo): el regalo es DE PEDIDO y lo que ya había en el carrito cuenta
    // (spec §Estado); se dice siempre, y el texto dice cuántos regalos se eligen.
    var other = state.cartOtherTotal > 0 ? ' Cuenta también lo que ya tienes en el carrito (' + moneyShort(state.cartOtherTotal) + ').' : '';
    // Pack vacío, tres casos según lo que ya hay en el carrito («resto»): nada → motivador; resto por
    // debajo del umbral → lo que falta; resto por encima → ya tiene regalo, se elige en el carrito o
    // aquí al montar el pack (el builder solo escribe en el carrito con el botón grande). El texto
    // nunca pone el pack como condición del regalo.
    if (units() === 0) {
      if (!state.cartOtherTotal) return 'A partir de <b>' + moneyShort(T1) + '</b> de pedido eliges uno gratis.';
      if (n === 0) return 'Te faltan <b>' + moneyShort(falta) + '</b> para elegir un regalo gratis.' + other;
      return n === 1 ? 'Con lo que ya tienes en el carrito (<b>' + moneyShort(state.cartOtherTotal) + '</b>) ya tienes <b>1 regalo</b>. Elígelo en el carrito, o aquí cuando montes tu pack.' : 'Con lo que ya tienes en el carrito (<b>' + moneyShort(state.cartOtherTotal) + '</b>) ya tienes <b>' + n + ' regalos</b>. Elígelos en el carrito, o aquí cuando montes tu pack.';
    }
    var txt;
    if (n === 0) {
      txt = 'Te faltan <b>' + moneyShort(falta) + '</b> para elegir un regalo gratis.';
    } else if (n === 1 && falta > 0) {
      txt = 'Elige <b>1 regalo</b>: va gratis en el pedido. Con <b>' + moneyShort(falta) + '</b> más eliges otro.';
    } else if (n === 1) {
      txt = 'Elige <b>1 regalo</b>: va gratis en el pedido.';
    } else {
      txt = 'Elige <b>' + n + ' regalos</b>: van gratis en el pedido.';
    }
    return txt + other;
  }

  function packSig() {
    return state.pack.map(function (l) { return l.variantId + ':' + l.qty; }).sort().join(',') +
      '|' + state.gifts.slice().sort().join(',');
  }
  function hasPendingChanges() { return state.inCart && packSig() !== state.cartSig; }

  /**
   * Qué hace el botón grande. El pack se edita en la página y se aplica de golpe al carrito
   * (borrar líneas viejas + añadir las nuevas en una sola operación). Antes el botón decía
   * siempre «Añadir al carrito», también con un pack ya en el carrito, y daba a entender que se
   * iba a añadir un SEGUNDO pack; y si bajabas de 2 productos se quedaba muerto sin forma de
   * quitar el pack. Decisión UX de Paolo (4-sep-2026): confirmación explícita, nunca
   * sincronizar en vivo (dos llamadas por pulsación en móvil lento), pero con el texto honesto.
   *   'pick'   → faltan productos y no hay pack en el carrito: botón desactivado
   *   'remove' → faltan productos pero HAY pack en el carrito: «Quitar el pack del carrito»
   *   'view'   → el pack de la página es exactamente el del carrito: «Ver el carrito»
   *   'update' → hay pack en el carrito y cambios: «Actualizar el pack»
   *   'add'    → no hay pack en el carrito: «Añadir al carrito»
   */
  function ctaMode() {
    var u = units();
    if (u < MIN_UNITS) return state.inCart ? 'remove' : 'pick';
    if (state.inCart) return hasPendingChanges() ? 'update' : 'view';
    return 'add';
  }

  // Doble toque para quitar el pack, igual que el ELIMINAR del drawer (decisión de Paolo).
  var removeArmed = false, removeTimer = null;

  function ctaText() {
    var u = units(), mode = ctaMode();
    if (mode === 'pick') {
      var falta = MIN_UNITS - u;
      return 'Elige ' + falta + ' ' + plural(falta, 'producto más', 'productos más');
    }
    if (mode === 'remove') return removeArmed ? 'Toca otra vez para quitarlo' : 'Quitar el pack del carrito';
    if (mode === 'view') return 'Ver el carrito';
    if (mode === 'update') return 'Actualizar el pack (' + u + ') · ' + money(packTotal());
    return 'Añadir al carrito (' + u + ') · ' + money(packTotal());
  }

  // ---------------------------------------------------------------- render
  var $ = function (sel) { return root.querySelector(sel); };

  function renderLadder() {
    var u = units(), nt = nextTier();
    [].forEach.call(root.querySelectorAll('[data-ndk-tier]'), function (el) {
      var min = parseInt(el.dataset.minUnits, 10);
      el.classList.toggle('ndk-pack__tier--on', u >= min);
      el.classList.toggle('ndk-pack__tier--next', !!nt && nt.min_units === min);
    });
  }

  function renderCards() {
    var p = pct();
    cards.forEach(function (el) {
      var item = catalog[el.dataset.variantId];
      var line = find(item.variantId);
      var qty = line ? line.qty : 0;

      // El descuento es DEL PACK: en cuanto hay tramo, las 27 cards enseñan precio tachado.
      var badge = el.querySelector('[data-ndk-badge]');
      var was = el.querySelector('[data-ndk-was]');
      var now = el.querySelector('[data-ndk-now]');
      if (p > 0) {
        badge.textContent = '-' + p + '%';
        badge.hidden = false;
        was.textContent = money(item.price);
        was.hidden = false;
        now.textContent = money(unitFinal(item.price, p));
      } else {
        badge.hidden = true;
        was.hidden = true;
        now.textContent = money(item.price);
      }

      var add = el.querySelector('[data-ndk-add]');
      var stepper = el.querySelector('[data-ndk-stepper]');
      if (add && stepper) {
        add.hidden = qty > 0;
        stepper.hidden = qty === 0;
        if (qty > 0) el.querySelector('[data-ndk-qty]').textContent = qty;
      }
      el.classList.toggle('ndk-pack-card--in', qty > 0);
    });
  }

  // Firma de la lista: si no cambia, no se reconstruye el DOM. Sin esto, cada `+` recreaba las
  // <img> y el panel parpadeaba en cada pulsación — muy visible en móviles lentos.
  var linesSignature = null;

  function renderLines() {
    var list = $('[data-ndk-lines]');
    var p = pct();
    var sig = state.pack.map(function (l) { return l.variantId; }).join(',');

    if (sig === linesSignature && sig !== '') {
      state.pack.forEach(function (l) {
        var node = list.querySelector('[data-ndk-line="' + l.variantId + '"]');
        if (!node) return;
        var it = catalog[l.variantId];
        node.querySelector('.ndk-pack-stepper__qty').textContent = l.qty;
        node.querySelector('.ndk-pack__line-sub').textContent =
          lineSubtitle({ days: it.days, qty: l.qty, unitDesc: it.unitDesc });
        node.querySelector('.ndk-pack__line-now').textContent = money(lineFinal(l));
        var wasEl = node.querySelector('.ndk-pack__line-was');
        if (wasEl) { wasEl.textContent = money(lineGross(l)); wasEl.hidden = p === 0; }
      });
      $('[data-ndk-pack-label]').textContent = 'Tu pack (' + state.pack.length + ')';
      return;
    }
    linesSignature = sig;

    list.innerHTML = state.pack.map(function (l) {
      var it = catalog[l.variantId];
      var gross = lineGross(l), fin = lineFinal(l);
      return '<li class="ndk-pack__line" data-ndk-line="' + it.variantId + '">' +
        '<img class="ndk-pack__line-img" src="' + esc(it.image) + '" width="56" height="56" alt="" loading="lazy">' +
        '<div>' +
          '<p class="ndk-pack__line-name">' + esc(it.title) + '</p>' +
          '<p class="ndk-pack__line-sub">' + esc(lineSubtitle({ days: it.days, qty: l.qty, unitDesc: it.unitDesc })) + '</p>' +
          '<div class="ndk-pack-stepper">' +
            '<button type="button" class="ndk-pack-stepper__btn" data-ndk-line-dec aria-label="Quitar una unidad de ' + esc(it.title) + '">&minus;</button>' +
            '<span class="ndk-pack-stepper__qty">' + l.qty + '</span>' +
            '<button type="button" class="ndk-pack-stepper__btn" data-ndk-line-inc aria-label="Añadir una unidad de ' + esc(it.title) + '">+</button>' +
          '</div>' +
        '</div>' +
        '<div class="ndk-pack__line-prices">' +
          '<s class="ndk-pack__line-was"' + (p > 0 ? '' : ' hidden') + '>' + money(gross) + '</s>' +
          '<span class="ndk-pack__line-now">' + money(fin) + '</span>' +
          '<button type="button" class="ndk-pack__line-remove" data-ndk-line-remove>Quitar</button>' +
        '</div>' +
      '</li>';
    }).join('');

    $('[data-ndk-placeholder]').hidden = state.pack.length > 0;
    $('[data-ndk-pack-label]').textContent = state.pack.length ? 'Tu pack (' + state.pack.length + ')' : 'Tu pack';
  }

  // Candado de los regalos bloqueados (inline: sin fuente de emoji ni petición extra).
  var LOCK_SVG = '<svg class="ndk-pack__gift-lock" viewBox="0 0 16 16" width="12" height="12" aria-hidden="true"><rect x="3" y="7" width="10" height="8" rx="2" fill="currentColor"/><path d="M5 7V5a3 3 0 0 1 6 0v2" fill="none" stroke="currentColor" stroke-width="1.6"/></svg>';

  var CHECK_SVG = '<svg class="ndk-pack__gift-check" viewBox="0 0 16 16" width="12" height="12" aria-hidden="true"><path d="M3 8.5l3 3 7-7" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function renderGifts() {
    var box = $('[data-ndk-gifts]');
    if (!GIFTS.length) { box.hidden = true; return; }
    box.hidden = false;
    $('[data-ndk-gift-text]').innerHTML = giftTextHTML();

    // Pack vacío (Paolo, 9-sep): el bloque se atenúa y no reacciona aunque lo que ya hay en el
    // carrito desbloquee regalos; si no, un carrito con 90 € enseñaba «Es tuyo ✓» sin pack.
    // Candado = no se llega al importe. Atenuado sin candado = ya lo tiene por lo que hay en el
    // carrito, pero se gestiona allí hasta que el pack tenga productos (acordado con Paolo 9-sep).
    var inactive = units() === 0;
    box.classList.toggle('ndk-pack__gifts--inactive', inactive);
    var allowed = giftCount();
    $('[data-ndk-gift-list]').innerHTML = GIFTS.map(function (g) {
      var chosen = state.gifts.indexOf(g.variant_id) > -1;
      var locked = allowed === 0;
      var cls = 'ndk-pack__gift' + (locked ? ' ndk-pack__gift--locked' : '') + (chosen ? ' ndk-pack__gift--chosen' : '');
      // Con los huecos llenos, el resto ofrece «cambiar» (toggleGift sustituye el más antiguo), no «elegir».
      var full = !chosen && state.gifts.length >= allowed;
      var action = locked
        ? ((g.compare_at_price ? '<s>' + money(g.compare_at_price) + '</s>' : 'Bloqueado'))
        : (chosen ? 'Es tuyo ✓' : (full ? 'Elegir este' : 'Elegir'));
      return '<li class="' + cls + '" data-ndk-gift="' + g.variant_id + '">' +
        // Candado sutil sobre la foto mientras no se llega al importe (petición de Paolo, 9-sep).
        '<span class="ndk-pack__gift-media"><img src="' + esc(g.image) + '" width="100" height="100" alt="" loading="lazy">' +
          (locked ? '<span class="ndk-pack__gift-lockbadge">' + LOCK_SVG + '</span>' : chosen ? '<span class="ndk-pack__gift-checkbadge">' + CHECK_SVG + '</span>' : '') + '</span>' +
        '<p class="ndk-pack__gift-name">' + esc(g.title) + '</p>' +
        '<button type="button" class="ndk-pack__gift-action"' + (locked ? ' disabled' : '') + '>' + action + '</button>' +
      '</li>';
    }).join('');

    // Banda de regalo de móvil: mismas miniaturas, mismo texto.
    var band = $('[data-ndk-giftband]');
    band.hidden = false;
    $('[data-ndk-giftband-thumbs]').innerHTML = GIFTS.slice(0, 3).map(function (g) {
      return '<img src="' + esc(g.image) + '" width="34" height="34" alt="" loading="lazy">';
    }).join('');
    $('[data-ndk-giftband-text]').innerHTML = giftTextHTML().replace('<br>', ' ');
  }

  function renderSummary() {
    var sum = $('[data-ndk-summary]');
    if (!state.pack.length) { sum.hidden = true; return; }
    sum.hidden = false;
    var u = units();
    $('[data-ndk-sum-units]').textContent = u + ' ' + plural(u, 'producto', 'productos');
    $('[data-ndk-sum-subtotal]').textContent = money(packSubtotal());

    var d = packDiscount();
    $('[data-ndk-sum-discount-row]').hidden = d === 0;
    if (d > 0) {
      $('[data-ndk-sum-pct]').textContent = '−' + pct() + '%';
      $('[data-ndk-sum-discount]').textContent = '−' + money(d);
    }
    $('[data-ndk-sum-gift-row]').hidden = state.gifts.length === 0 || units() === 0;
    $('[data-ndk-sum-total]').textContent = money(packTotal());
  }

  function renderBar() {
    var bar = $('[data-ndk-bar]');
    bar.hidden = false;
    $('[data-ndk-bar-headline]').innerHTML = headlineHTML();
    $('[data-ndk-bar-label]').textContent = state.pack.length ? 'Tu pack (' + units() + ')' : 'Pack vacío';

    var thumbs = state.pack.slice(0, 3).map(function (l) {
      return '<img src="' + esc(catalog[l.variantId].image) + '" width="34" height="34" alt="" loading="lazy">';
    }).join('');
    thumbs += '<span class="ndk-pack__bar-slot" aria-hidden="true">' +
      '<svg viewBox="0 0 24 24" width="16" height="16"><path d="M3 8h18v12H3zM3 8l2-4h14l2 4M12 8v12" stroke="#8cc7c5" stroke-width="1.6" fill="none"/></svg></span>';
    $('[data-ndk-bar-thumbs]').innerHTML = thumbs;

    // La barra no puede tapar el último producto del grid.
    root.style.setProperty('--ndk-bar-h', bar.offsetHeight + 'px');
  }

  function renderCTA() {
    var mode = ctaMode(), txt = ctaText(), ok = mode !== 'pick' && !state.busy;
    [].forEach.call(root.querySelectorAll('[data-ndk-cta], [data-ndk-bar-cta]'), function (b) {
      b.textContent = txt;
      b.disabled = !ok;
      b.classList.toggle('ndk-pack__cta--busy', state.busy);
      b.classList.toggle('ndk-pack__cta--secondary', mode === 'view' || mode === 'remove');
    });
    var pending = mode === 'update' || mode === 'remove';
    [].forEach.call(root.querySelectorAll('[data-ndk-pending]'), function (el) { el.hidden = !pending; });
  }

  function render() {
    renderLadder();
    renderCards();
    renderLines();
    renderGifts();
    renderSummary();
    renderCTA();
    $('[data-ndk-headline]').innerHTML = headlineHTML();
    renderBar();
    renderDrawerFoot();
  }

  // ---------------------------------------------------------------- acciones sobre el pack
  function addUnit(variantId) {
    var it = catalog[variantId];
    if (!it || !it.available) return;
    var line = find(variantId);
    if (line) line.qty += 1; else state.pack.push({ variantId: variantId, qty: 1 });
    state.dirty = true;
    disarmRemove();
    render();
    ga('add_to_pack', { item_id: it.productId, item_name: it.title, units: units(), tier_pct: pct() });
  }

  function removeUnit(variantId) {
    var line = find(variantId);
    if (!line) return;
    line.qty -= 1;
    if (line.qty <= 0) state.pack = state.pack.filter(function (l) { return l.variantId !== variantId; });
    state.dirty = true;
    disarmRemove();
    pruneGifts();
    render();
    ga('remove_from_pack', { item_id: catalog[variantId].productId, units: units(), tier_pct: pct() });
  }

  function removeLine(variantId) {
    state.pack = state.pack.filter(function (l) { return l.variantId !== variantId; });
    state.dirty = true;
    disarmRemove();
    pruneGifts();
    render();
    ga('remove_from_pack', { item_id: catalog[variantId].productId, units: units(), tier_pct: pct() });
  }

  // Si el pack baja de umbral, los regalos sobrantes se caen solos — igual que hace utcart.
  function pruneGifts() {
    var allowed = giftCount();
    if (state.gifts.length > allowed) state.gifts = state.gifts.slice(0, allowed);
  }

  function toggleGift(variantId) {
    if (units() === 0) return;
    var allowed = giftCount();
    if (allowed === 0) return;
    var i = state.gifts.indexOf(variantId);
    if (i > -1) state.gifts.splice(i, 1);
    else {
      if (state.gifts.length >= allowed) state.gifts.shift();
      state.gifts.push(variantId);
      ga('select_gift', { gift_id: variantId, gift_slot: state.gifts.length });
    }
    state.dirty = true;
    disarmRemove();
    render();
  }

  // ---------------------------------------------------------------- carrito

  function isGiftItem(i) {
    return i.price === 0 || (i.sku && i.sku.indexOf('regalo_') === 0) ||
      (i.variant_title && i.variant_title.indexOf('_regalo_') > -1);
  }

  function loadCart() {
    if (state.busy) return Promise.resolve();
    var gen = ++loadGen;
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // Llegó tarde: hay una lectura más nueva o el cliente está en plena operación. No pisamos nada.
        if (gen !== loadGen || state.busy) return;

        // NDK 9-sep-2026 (revisión Paolo): con cambios sin confirmar en el pack (`dirty`) mandan
        // los del cliente y no se toca `pack`, pero lo que hay en el carrito AJENO al pack sí se
        // relee: si quita un producto desde el drawer, el texto del regalo («cuenta también lo
        // que ya tienes en el carrito») tiene que bajar al momento. Antes se quedaba congelado.
        if (state.dirty) {
          state.cartOtherTotal = cart.items.reduce(function (n, i) {
            var isPack = i.properties && i.properties._ndk_pack;
            return (isPack || isGiftItem(i)) ? n : n + i.final_line_price;
          }, 0);
          pruneGifts();
          render();
          return;
        }

        state.pack = [];
        state.gifts = [];
        state.cartOtherTotal = 0;
        state.inCart = false;

        cart.items.forEach(function (i) {
          var isPack = i.properties && i.properties._ndk_pack;
          if (isPack) {
            state.inCart = true;
            // Si la variante ya no está en el catálogo (se agotó, perdió el tag, se despublicó)
            // no se puede pintar, pero TAMPOCO cuenta como «lo que ya traía»: es una línea del
            // pack y el próximo CTA la va a borrar junto con las demás.
            if (catalog[String(i.variant_id)]) {
              state.pack.push({ variantId: String(i.variant_id), qty: i.quantity });
            }
          } else if (isGiftItem(i)) {
            state.gifts.push(i.variant_id);
          } else {
            // Lo que el cliente ya traía cuenta para el REGALO, nunca para el tramo.
            state.cartOtherTotal += i.final_line_price;
          }
        });
        pruneGifts();
        state.cartSig = packSig();
        state.dirty = false;
        disarmRemove();
        render();
      })
      .catch(function (e) { console.warn('NDK Pack: no se pudo leer el carrito', e); render(); });
  }

  /**
   * Claves de línea del pack y de los regalos LEÍDAS EN ESTE INSTANTE.
   * Antes se usaba una foto tomada al cargar la página, y eso rompía en tres escenarios: una
   * línea de un producto que salió del catálogo nunca entraba en la lista y sobrevivía al
   * borrado (el cliente pagaba algo que no podía ni ver), dos pestañas abiertas se pisaban, y
   * cualquier cambio hecho desde el drawer dejaba las claves obsoletas.
   */
  function currentCartKeys() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var keys = [];
        cart.items.forEach(function (i) {
          if ((i.properties && i.properties._ndk_pack) || isGiftItem(i)) keys.push(i.key);
        });
        return keys;
      });
  }

  function disarmRemove() {
    removeArmed = false;
    if (removeTimer) { clearTimeout(removeTimer); removeTimer = null; }
  }

  function primaryAction() {
    if (state.busy) return;
    var mode = ctaMode();
    if (mode === 'view') { openCartDrawer(); return; }
    if (mode === 'remove') {
      if (!removeArmed) {
        removeArmed = true;
        renderCTA();
        removeTimer = setTimeout(function () { disarmRemove(); renderCTA(); }, 4000);
        return;
      }
      disarmRemove();
      return removePackFromCart();
    }
    if (mode === 'update' || mode === 'add') return addToCart();
  }

  // Quita del carrito el pack entero (y sus regalos), en UNA llamada, como hace el drawer:
  // borrar línea a línea haría subir el precio de las que quedan entre llamada y llamada.
  function removePackFromCart() {
    state.busy = true;
    renderCTA();
    return currentCartKeys()
      .then(function (keys) {
        if (!keys.length) return null;
        var updates = {};
        keys.forEach(function (k) { updates[k] = 0; });
        return fetch('/cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        });
      })
      .then(function (r) {
        if (r && !r.ok) throw new Error('update.js ' + r.status);
        ga('remove_pack', { units: units() });
        state.pack = [];
        state.gifts = [];
        state.dirty = false;
        state.busy = false;
        return loadCart();
      })
      .then(openCartDrawer)
      .catch(function (e) {
        console.error('NDK Pack: fallo al quitar el pack', e);
        state.busy = false;
        state.dirty = false;
        loadCart();
        alert('No se ha podido quitar el pack. Vuelve a intentarlo en unos segundos.');
      })
      .then(function () { state.busy = false; renderCTA(); });
  }

  function addToCart() {
    if (state.busy || units() < MIN_UNITS) return;
    state.busy = true;
    renderCTA();

    var items = state.pack.map(function (l) {
      return { id: parseInt(l.variantId, 10), quantity: l.qty, properties: { _ndk_pack: '1' } };
    });
    state.gifts.forEach(function (id) { items.push({ id: id, quantity: 1 }); });

    var total = packTotal(), u = units(), p = pct();

    // Un solo camino: se vacían TODAS las líneas del pack y de los regalos que haya en el carrito
    // AHORA MISMO, y se añade el pack nuevo. Las claves se leen en este instante, no de una foto
    // vieja: así se limpian también las líneas de productos que ya no están en el catálogo y no
    // importa lo que haya hecho otra pestaña.
    return currentCartKeys()
      .then(function (keys) {
        if (!keys.length) return null;
        var updates = {};
        keys.forEach(function (k) { updates[k] = 0; });
        return fetch('/cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        });
      })
      .then(function (r) {
        // Si el vaciado falla y seguimos adelante, Shopify FUSIONA las líneas nuevas con las
        // viejas y el cliente acaba pagando el doble. Abortar aquí es lo único correcto.
        if (r && !r.ok) throw new Error('update.js ' + r.status);
        return fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        });
      })
      .then(function (r) { if (!r.ok) throw new Error('add.js ' + r.status); return r.json(); })
      .then(function () {
        ga('add_to_cart', {
          currency: 'EUR',
          value: total / 100,
          items: gaItems(),
          units: u,
          tier_pct: p
        });
        state.dirty = false;          // lo de la página ya está en el carrito
        state.busy = false;           // para que loadCart no se descarte a sí mismo
        return loadCart();
      })
      .then(openCartDrawer)
      .catch(function (e) {
        console.error('NDK Pack: fallo al añadir al carrito', e);
        // El vaciado puede haber borrado líneas antes del fallo: hay que releer el carrito de
        // verdad en vez de dejar la página enseñando algo que ya no existe.
        state.busy = false;
        state.dirty = false;
        loadCart();
        alert('No se ha podido añadir el pack. Vuelve a intentarlo en unos segundos.');
      })
      .then(function () { state.busy = false; renderCTA(); });
  }

  /**
   * utcart-v2 NO tiene sistema de eventos: su única interfaz pública son tres globales
   * (`assets/utcart-v2.js:1722-1724`). Es también como lo abre el resto del theme — el icono de
   * la cabecera hace `onclick="openCart()"` en `snippets/header-icons.liquid:55`.
   * `openCart({ stale: true })` relee /cart.js y se repinta solo, así que no hay que refrescarlo a mano.
   *
   * Antes esto disparaba eventos `utcart:open` / `cart:refresh` que no escucha nadie y buscaba
   * selectores que no existen en el DOM: el cliente añadía el pack y no veía absolutamente nada.
   */
  function openCartDrawer() {
    closeSheet(); // en móvil el CTA vive dentro de la hoja: hay que cerrarla o quedan dos capas
    // Este script va `async` desde el 4-sep-2026 (los botones responden ~4 s antes en móvil lento),
    // así que puede correr ANTES de que utcart-v2.js, que es diferido, defina openCart. Se espera
    // hasta 8 s antes de caer a /cart, que es el mismo fallback de siempre (utcart-v2.js:26 no
    // expone openCart si falta el markup del drawer).
    var waited = 0;
    (function tryOpen() {
      // `stale`: el carrito acaba de cambiar y utcart no lo sabe; así enseña el spinner y no el
      // carrito anterior mientras relee cart.js (utcart-v2.js, openCart).
      if (typeof window.openCart === 'function') { window.openCart({ stale: true }); return; }
      if (waited < 8000) { waited += 100; setTimeout(tryOpen, 100); return; }
      window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
    })();
  }

  // ---------------------------------------------------------------- hoja móvil
  function openSheet() {
    $('[data-ndk-panel]').classList.add('ndk-pack__panel--open');
    var scrim = $('[data-ndk-scrim]');
    scrim.hidden = false;
    requestAnimationFrame(function () { scrim.classList.add('ndk-pack__scrim--on'); });
    document.body.style.overflow = 'hidden';
  }
  function closeSheet() {
    $('[data-ndk-panel]').classList.remove('ndk-pack__panel--open');
    var scrim = $('[data-ndk-scrim]');
    scrim.classList.remove('ndk-pack__scrim--on');
    setTimeout(function () { scrim.hidden = true; }, 220);
    document.body.style.overflow = '';
  }

  // ---------------------------------------------------------------- cajón de la ficha (ⓘ)
  var pdpCache = {};
  var drawerVariant = null;
  // Mismo punto de corte que el CSS del cajón (panel lateral de 480 px a partir de 990 px).
  var DESKTOP_DRAWER = window.matchMedia ? window.matchMedia('(min-width: 990px)') : { matches: false };

  function openInfo(variantId) {
    var it = catalog[variantId];
    if (!it) return;
    drawerVariant = variantId;

    var drawer = $('[data-ndk-drawer]');
    var body = $('[data-ndk-drawer-body]');
    var scrim = $('[data-ndk-scrim]');
    drawer.hidden = false;
    scrim.hidden = false;
    requestAnimationFrame(function () {
      drawer.classList.add('ndk-pack__drawer--open');
      scrim.classList.add('ndk-pack__scrim--on');
    });
    document.body.style.overflow = 'hidden';
    renderDrawerFoot();

    body.innerHTML = '<p class="ndk-pack__drawer-loading">Cargando la ficha…</p>';

    /**
     * ESCRITORIO (8-sep-2026, revisión de Paolo): el cajón es un panel de 480 px. Inyectar el fragmento aquí
     * hacía que la ficha aplicara sus media queries de escritorio (timeline a dos columnas, titulares enormes)
     * en una columna estrecha. Ahora la ficha va en un <iframe> con `templates/product.pack-frame.liquid`:
     * dentro, el viewport ES el ancho del cajón y se aplican solas las mismas reglas que en un móvil, que es
     * el diseño de referencia. En móvil se sigue inyectando el fragmento (sin iframe).
     * El storefront de Shopify manda `frame-ancestors 'none'`: un iframe con `src` se queda vacío. Con `srcdoc`
     * el documento es del mismo origen y no pasa por esas cabeceras; el HTML se pide con fetch (misma URL,
     * mismas cookies) y se cachea como el fragmento móvil.
     */
    if (DESKTOP_DRAWER.matches) {
      var frame = document.createElement('iframe');
      frame.className = 'ndk-pack__drawer-frame';
      frame.title = it.title;
      frame.hidden = true;
      frame.addEventListener('load', function () {
        if (drawerVariant !== variantId) return;
        var loading = body.querySelector('.ndk-pack__drawer-loading');
        if (loading) loading.remove();
        frame.hidden = false;
      });
      body.appendChild(frame);
      var key = 'frame:' + it.handle;
      var ready = pdpCache[key] ? Promise.resolve(pdpCache[key])
        : fetch('/products/' + it.handle + '?view=pack-frame').then(function (r) { return r.text(); });
      ready
        .then(function (html) {
          pdpCache[key] = html;
          if (drawerVariant === variantId) frame.srcdoc = html;
        })
        .catch(function () {
          body.innerHTML = '<p class="ndk-pack__drawer-loading">No se ha podido cargar la ficha. Vuelve a intentarlo en unos segundos.</p>';
        });
      return;
    }

    if (pdpCache[it.handle]) { body.innerHTML = pdpCache[it.handle]; decorateFragment(body, it); body.scrollTop = 0; return; }

    // `templates/product.pack.liquid` lleva `layout none` y pinta SOLO los campos de la ficha que
    // sirven para decidir (ver la cabecera de esa plantilla): la respuesta es el fragmento exacto.
    fetch('/products/' + it.handle + '?view=pack')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        pdpCache[it.handle] = html;
        if (drawerVariant === variantId) { body.innerHTML = html; decorateFragment(body, it); body.scrollTop = 0; }
      })
      .catch(function () {
        // Sin enlace a la PDP: desde el cajón no se sale a ningún sitio (decisión de Paolo).
        body.innerHTML = '<p class="ndk-pack__drawer-loading">No se ha podido cargar la ficha. Vuelve a intentarlo en unos segundos.</p>';
      });
  }

  /**
   * El fragmento llega inerte por innerHTML: hay que (1) ejecutar sus <script> (los acordeones
   * «Cómo tomarlo» / «Ingredientes» y las tarjetas de activos de la PDP se montan con JS propio),
   * (2) arrancar los desplegables del theme para las preguntas, (3) rellenar las estrellas eKomi
   * con los datos que la card ya tiene (cero peticiones) y (4) quitar cualquier enlace: desde el
   * cajón no se sale a ningún sitio.
   */
  function decorateFragment(container, it) {
    container.querySelectorAll('script').forEach(function (old) {
      var sc = document.createElement('script');
      [].forEach.call(old.attributes, function (a) { sc.setAttribute(a.name, a.value); });
      sc.textContent = old.textContent;
      old.parentNode.replaceChild(sc, old);
    });
    try { if (window.theme && theme.collapsibles && theme.collapsibles.init) theme.collapsibles.init(); } catch (e) { /* sin desplegables no se rompe nada */ }

    var row = container.querySelector('.ndk-ekomi-stars');
    var srcRating = it.el.querySelector('.ndk-col-stars__rating');
    var srcCount = it.el.querySelector('.ndk-col-stars__count');
    if (row && srcRating && srcRating.textContent.trim()) {
      var r = row.querySelector('[data-ndk-rating]'), c = row.querySelector('[data-ndk-count]');
      if (r) r.textContent = srcRating.textContent.trim();
      // Mismo texto que pone la ficha («Leer 459 opiniones»): la card solo guarda «459 opiniones».
      var n = srcCount ? (srcCount.textContent.match(/\d[\d.]*/) || [''])[0] : '';
      if (c && n) c.textContent = 'Leer ' + n + ' opiniones';
      row.style.display = '';
    }
    container.querySelectorAll('a[href]').forEach(function (a) { a.removeAttribute('href'); });
  }

  /**
   * Pie del cajón: precio con el tramo ACTUAL del pack (el mismo que enseña la card) y «Añadir al
   * pack», o el contador si el producto ya está dentro. Se repinta con cada cambio del pack.
   */
  function renderDrawerFoot() {
    if (!drawerVariant) return;
    var it = catalog[drawerVariant];
    var p = pct(), line = find(drawerVariant), qty = line ? line.qty : 0;
    var was = $('[data-ndk-drawer-was]'), tier = $('[data-ndk-drawer-tier]');
    $('[data-ndk-drawer-now]').textContent = money(unitFinal(it.price, p));
    var fmt = $('[data-ndk-drawer-format]'), fmtTxt = lineSubtitle({ days: it.days, qty: 1, unitDesc: it.unitDesc });
    if (fmt) { fmt.textContent = fmtTxt; fmt.hidden = !fmtTxt; }
    was.textContent = money(it.price); was.hidden = p === 0;
    tier.textContent = '\u2212' + p + '% aplicado'; tier.hidden = p === 0;
    var cta = $('[data-ndk-drawer-cta]'), stepper = $('[data-ndk-drawer-stepper]');
    cta.hidden = qty > 0;
    cta.disabled = !it.available;
    stepper.hidden = qty === 0;
    $('[data-ndk-drawer-qty]').textContent = qty;
  }

  function closeInfo() {
    var drawer = $('[data-ndk-drawer]'), scrim = $('[data-ndk-scrim]');
    drawer.classList.remove('ndk-pack__drawer--open');
    scrim.classList.remove('ndk-pack__scrim--on');
    setTimeout(function () { drawer.hidden = true; scrim.hidden = true; }, 240);
    document.body.style.overflow = '';
    drawerVariant = null;
  }

  // ---------------------------------------------------------------- filtro
  function setupFilter() {
    var sel = $('[data-ndk-filter]');
    if (!sel) return;
    var counts = {};
    cards.forEach(function (el) {
      catalog[el.dataset.variantId].collections.forEach(function (h) { counts[h] = (counts[h] || 0) + 1; });
    });
    sel.options[0].textContent = 'Todos los productos (' + cards.length + ')';
    (CFG.categories || []).forEach(function (c) {
      if (!counts[c.handle]) return;
      var o = document.createElement('option');
      o.value = c.handle;
      o.textContent = c.label + ' (' + counts[c.handle] + ')';
      sel.appendChild(o);
    });

    sel.addEventListener('change', function () {
      var h = sel.value, shown = 0;
      cards.forEach(function (el) {
        var ok = !h || catalog[el.dataset.variantId].collections.indexOf(h) > -1;
        el.hidden = !ok;
        if (ok) shown++;
      });
      $('[data-ndk-count]').textContent = shown + ' ' + plural(shown, 'producto', 'productos');
    });
    $('[data-ndk-count]').textContent = cards.length + ' productos';
  }

  // ---------------------------------------------------------------- eventos
  root.addEventListener('click', function (e) {
    var card = e.target.closest('[data-ndk-card]');
    if (card) {
      var vid = card.dataset.variantId;
      if (e.target.closest('[data-ndk-add]') || e.target.closest('[data-ndk-inc]')) return addUnit(vid);
      if (e.target.closest('[data-ndk-dec]')) return removeUnit(vid);
      if (e.target.closest('[data-ndk-info]')) return openInfo(vid);
    }

    var line = e.target.closest('[data-ndk-line]');
    if (line) {
      var lvid = line.dataset.ndkLine;
      if (e.target.closest('[data-ndk-line-inc]')) return addUnit(lvid);
      if (e.target.closest('[data-ndk-line-dec]')) return removeUnit(lvid);
      if (e.target.closest('[data-ndk-line-remove]')) return removeLine(lvid);
    }

    var gift = e.target.closest('[data-ndk-gift]');
    // Todo el bloque del regalo es clicable, no solo el botón (usabilidad, Paolo 9-sep-2026).
    if (gift) return toggleGift(parseInt(gift.dataset.ndkGift, 10));

    if (e.target.closest('[data-ndk-cta]') && !e.target.closest('[data-ndk-drawer-cta]')) return primaryAction();
    if (e.target.closest('[data-ndk-bar-cta]')) return primaryAction();
    if (e.target.closest('[data-ndk-bar-edit]')) return openSheet();
    if (e.target.closest('[data-ndk-sheet-close]')) return closeSheet();
    // El scrim lo comparten la hoja del pack y el cajón de la ficha: cierra el que esté abierto.
    if (e.target.closest('[data-ndk-scrim]')) return drawerVariant ? closeInfo() : closeSheet();
    if (e.target.closest('[data-ndk-drawer-close]')) return closeInfo();
    if (e.target.closest('[data-ndk-drawer-inc]')) { if (drawerVariant) addUnit(drawerVariant); return; }
    if (e.target.closest('[data-ndk-drawer-dec]')) { if (drawerVariant) removeUnit(drawerVariant); return; }
    if (e.target.closest('[data-ndk-drawer-cta]')) {
      // Añadir desde la ficha cierra el cajón: el cliente vuelve al grid y ve la card ya dentro.
      if (drawerVariant) addUnit(drawerVariant);
      return closeInfo();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (!$('[data-ndk-drawer]').hidden) closeInfo();
    else if ($('[data-ndk-panel]').classList.contains('ndk-pack__panel--open')) closeSheet();
  });

  /**
   * RESINCRONIZACIÓN. El cliente puede tocar el carrito por su cuenta —quitar líneas del pack en
   * el drawer, volver desde /cart o desde el checkout— y entonces la página se queda mintiendo:
   * enseñaría 7 productos y −25% con un carrito que solo tiene uno. El descuento real SÍ se
   * recalcula solo (lo hace la function en el servidor); lo que se queda viejo es esta página.
   *
   * utcart no tiene eventos que avisen, así que se vigila la clase del overlay: cuando pierde
   * `utcart--open` es que el drawer se ha cerrado y toca releer el carrito. Es observación pasiva,
   * no se toca ni una línea de utcart.
   */
  function watchCart() {
    var overlay = document.getElementById('utcart-overlay');
    // El markup de utcart va DESPUÉS de esta sección en layout/theme.liquid. Con el script en
    // `async` podemos arrancar antes de que el parser llegue a él: se reintenta al terminar de
    // parsear, que es cuando corría todo esto con `defer`.
    if (!overlay && document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', watchCart, { once: true });
      return;
    }
    if (overlay && window.MutationObserver) {
      var wasOpen = overlay.classList.contains('utcart--open');
      new MutationObserver(function () {
        var isOpen = overlay.classList.contains('utcart--open');
        // Al cerrarse el drawer se relee el carrito, PERO loadCart respeta state.dirty: si el
        // cliente tiene cambios sin confirmar, mandan los suyos. Antes esto le borraba en
        // silencio los productos que acababa de elegir.
        if (wasOpen && !isOpen) loadCart();
        wasOpen = isOpen;
      }).observe(overlay, { attributes: true, attributeFilter: ['class'] });
    }
    // Vuelta atrás del navegador desde /cart o el checkout: la página sale de la caché.
    window.addEventListener('pageshow', function (e) { if (e.persisted) loadCart(); });
  }

  // ---------------------------------------------------------------- arranque
  setupFilter();
  render();
  // Desde «Editar el pack» del carrito (?edit=1): en móvil se abre directamente la hoja del pack,
  // que es a lo que viene el cliente; en escritorio el panel ya está a la vista. (Paolo, 9-sep-2026)
  loadCart().then(function () {
    if (!/[?&]edit=1(&|$)/.test(location.search)) return;
    if (window.history && history.replaceState) history.replaceState(null, '', location.pathname + location.hash);
    if (state.pack.length && !DESKTOP_DRAWER.matches) openSheet();
  });
  watchCart();
  ga('view_pack_builder', { catalog_size: cards.length });
})();
